import {useState} from 'react'
import _ from 'lodash'

const useForm = (callback, initFormValues) => {
    const init = initFormValues ? initFormValues : {}
    const [values, setValues] = useState(init)
    const isChanged = !_.isEqual(init, values)

    const handleSubmit = event => {
        if (event) {
            event.preventDefault()
            callback()
        }
    }

    const handleChange = event => {
        const value =
            event.target.type === 'checkbox'
                ? event.target.checked
                : event.target.value

        event.persist()
        setValues(values => ({
            ...values,
            [event.target.name]: value,
        }))
    }

    const resetField = (fieldname, value) => {
        //console.log('useForm resetField', fieldname + ' , ' + value)
        setValues(values => ({
            ...values,
            [fieldname]: value,
        }))
    }

    return {
        resetField,
        handleChange,
        handleSubmit,
        values,
        isChanged,
    }
}

export default useForm
